// import LandingFormWrapper from 'components/landingFormWrapper/LandingFormWrapper';
import LandingHero from 'components/landingHero/LandingHero';
import { userBasicInfoPublicPages } from 'modules/graphqlQueries';
// import { useRouter } from 'next/router';
import {
  LandingFormWrapperStyled,
  Person,
  PersonImage,
  PersonLine,
  PersonName,
  PersonRole,
  PersonText,
  Row,
  Section,
  SectionsTitle,
  SectionsTitleWrapper,
  Text,
  TitleLine,
} from 'styles/about-us.styles';

import Layout from '../components/layout/Layout';
import { useLoadData } from '../modules/useLoadData';
import { UserType } from '../types/UserTypes';

const getQuery = (userId) => `{
  user(_id: "${userId}") {
    ${userBasicInfoPublicPages}
  }
}`;

const AboutUs = (): JSX.Element => {
  const {
    isLoading,
    response: {
      data: { user },
    },
  } = useLoadData(getQuery);

  return (
    <Layout user={user as UserType} isLoading={isLoading} noExtraSpaceFooter>
      <LandingHero
        image="/maksym.webp"
        title="Who we are"
        text="bid2board ensures quality and efficiency, reduces the time required
        to arrange service and enhances visibility through a simple and
        automated platform"
      />
      <LandingFormWrapperStyled size={1408}>
        <Section>
          <SectionsTitleWrapper>
            <SectionsTitle>Our history</SectionsTitle>
          </SectionsTitleWrapper>
          <TitleLine />
          <Text>
            bid2board was born in 2020 by a team of young professionals who have
            dealt with marine service arrangement for several years. The idea
            behind bid2board derives from the ample room for improvement in
            terms of quality and efficiency that exists today in the marine
            technical service environment both for ship owners / managers and
            service suppliers. Having dealt with the existing challenges of the
            sector combined with the pioneering spirit and innovation drive of
            the team, we have created a platform in which marine technical
            service may become a simple, easy, and quick process ensuring
            quality and transparency. Our mission is to provide modernization
            into the matching of ship service supply and demand by shifting the
            service arrangement on a digital platform. <br />
            <br />
            The goals that lead the development of bid2board are: <br />
            <ul>
              <li>
                - to simplify the whole process of marine technical service
              </li>
              <li>- to ensure quality of provided services</li>
              <li>- to enhance visibility of service suppliers</li>
              <li>- to reduce the time spent in arrangements</li>
              <li>
                - to provide competition insights and discover opportunities
              </li>
              <li>- to offer the tools to improve operational efficiencies</li>
            </ul>
          </Text>
        </Section>
        <Section>
          <SectionsTitleWrapper>
            <SectionsTitle>Our Team</SectionsTitle>
          </SectionsTitleWrapper>
          <TitleLine />
          <Row>
            <Person>
              <PersonImage src="/ceo.jpg" />
              <PersonName>Andreas Zompanakis</PersonName>
              <PersonLine />
              <PersonRole>CEO &amp; Co-founder</PersonRole>
              <PersonText>
                Andreas Zompanakis is the CEO of bid2board. Before starting
                bid2board, he served as Technical Manager with LNG probunkers a
                green shipping start – up of global scale, as a Fleet Manager
                with Prime Tanker Management Inc. and as Superintendent Engineer
                with Anthony Veder Rederijzaken B.V. roles through which Andreas
                gained a deep knowledge of marine technical service
                requirements. Apart from being responsible for the development
                of the LNG bunkering ship of the future, with LNG probunkers
                Andreas participated in fundraising roadshows and was acquainted
                to the operations and challenges of a pioneering start-up
                company.
              </PersonText>
            </Person>
            {/* <Person>
              <PersonImage src="/cio.jpeg" />
              <PersonName>Michael Chartoularis</PersonName>
              <PersonLine />
              <PersonRole>COO &amp; Co-founder</PersonRole>
              <PersonText>
                Michael Chartoularis is the COO of bid2board and father of the
                original idea for the project. His experience in technical ship
                management comes from a career with Safety Bulkers Inc. and
                Pleiades Shipping Agents S.A., as well as serving in the
                position of DPA with Graham Shipping Co. His innovative spirit
                and ingenuity drove him to pursue new challenges by joining
                Amazon after having successfully completed his MBA studies at
                Insead. The deep knowledge and optimization skills he acquired
                are fundamental in the architecture of bid2board and continue to
                fuel the company’s efforts in optimizing the marine technical
                service sector.
              </PersonText>
            </Person> */}
            <Person>
              <PersonImage src="/cto.jpeg" />
              <PersonName>Achilleas Tsoumitas</PersonName>
              <PersonLine />
              <PersonRole>CTO &amp; Co-founder</PersonRole>
              <PersonText>
                Achilleas Tsoumitas is the CTO of bid2board and responsible for
                transforming our vision into a working online platform capable
                of revolutionizing the way that marine technical services are
                arranged today. Achilleas held leading roles in the past as
                Software Team Lead with JP Morgan London and as Principal
                Software Engineer with McKinsey London ensuring that state of
                the art technology and procedures are applied in the development
                of bid2board.
              </PersonText>
            </Person>
          </Row>
        </Section>
      </LandingFormWrapperStyled>
    </Layout>
  );
};

export default AboutUs;
